import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Section, FeedbackQuestions } from '../s'
import { H1 as Title } from 'components/typography/heading'
import Paragraph from 'components/typography/paragraph'

const SlackAbout = ({ name, upgradable }) => (
    <>
        <Section>
            <Title>{name}</Title>
            <Paragraph>
                <FormattedMessage
                    id="integration_slack_preamble_about"
                    defaultMessage="Huma isn’t just easier to use, it’s easy to integrate. Make sure that you and your team stay up to date by instantly turning Huma updates into messages in Slack. Now everyone will have the most up-to-date information and be able to work from both platforms — seamlessly." />
            </Paragraph>
        </Section>
        <FeedbackQuestions mode={upgradable ? 'support' : 'sales'} />
    </>
)

export default SlackAbout